// StomataLoader.jsx
import React from "react";
import "./StomataLoader.css";

function StomataLoader() {
  return (
    <div className="loader-container">
      <div className="stoma">
        <div className="pore"></div>
      </div>
      <p>Loading...</p>
    </div>
  );
}

export default StomataLoader;
